import React from 'react';
import { Form, Field } from 'react-final-form';
import trim from 'lodash/trim';
import Button from '@omilia/button';

import TextFieldFinalFormWrapper from 'components/TextFieldFinalFormWrapper';
import validate from '../../utils';

const VerifyForm = ({
  onSubmit,
}: {
  onSubmit: ({ email, password }: { email: string; password: string }) => void;
}) => (
  <Form validate={validate} onSubmit={onSubmit}>
    {({ handleSubmit, invalid, submitting }) => (
      <form data-test="form" onSubmit={handleSubmit}>
        <Field
          autoComplete="off"
          component={TextFieldFinalFormWrapper}
          data-test="email"
          label="Email"
          name="email"
          normalize={trim}
          placeholder="Enter your email"
          type="email"
        />
        <Field
          component={TextFieldFinalFormWrapper}
          data-test="password"
          label="Password"
          name="password"
          normalize={trim}
          placeholder="Enter your password"
          type="password"
        />
        <Button
          block
          color="primary"
          data-test="submit"
          disabled={invalid || submitting}
          loading={submitting}
          type="submit"
          variant="contained"
        >
          Verify your account
        </Button>
      </form>
    )}
  </Form>
);

export default VerifyForm;
